/* src/app/modules/home/components/vaccination-verifications/vaccination-verifications.component.scss */
.main-container .assessment-status {
  margin: 1.5rem 2%;
  padding: 0 2%;
  line-height: 1.5;
}
.main-container .assessment-status ul {
  margin-left: 2%;
}
.main-container .assessment-status.success {
  border-left: 0.188rem solid var(--flu-color-1);
}
.main-container .assessment-status.success .assessment-status__title {
  color: var(--flu-color-1);
}
.main-container .assessment-status.review {
  border-left: 0.188rem solid var(--brand-50);
}
.main-container .assessment-status.review .assessment-status__title {
  color: var(--brand-50);
}
.main-container .assessment-status__title {
  font-size: 1.4rem;
  font-weight: var(--font-weight-book);
  margin-bottom: 0.313rem;
}
.main-container .assessment-status__title a {
  font-size: 1.2rem;
  color: var(--brand-50);
  text-decoration: underline;
}
.main-container .assessment-status__description {
  font-weight: var(--font-weight-book);
}
.main-container .assessment-status p.assessment-status__description {
  margin: 0;
}
.main-container .outage {
  height: 5rem;
  padding: 0.625rem 0;
  margin-bottom: 0.938rem;
}
.main-container .outage .outage-text {
  margin-top: 0.313rem;
  color: var(--negative-3);
}
.main-container .outage .maintananca-icon {
  display: inline-block;
  margin: 0 0.625rem;
  width: 3.75rem;
  height: 3.75rem;
  background-image: url(https://content.workpartners.com/vaccine/icons/web-maintenance-icon.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.main-container.container-fluid {
  width: 100%;
  padding-right: 0.938rem;
  padding-left: 0.938rem;
  margin-right: auto;
  margin-left: auto;
}
.main-container.container-fluid .flu-shot {
  height: 5rem;
  padding: 0 1.25rem;
  font-size: 1.3rem;
  vertical-align: middle;
  border-bottom: 0.063rem solid #ddd;
  position: relative;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 60% 40%;
}
.main-container.container-fluid .flu-shot__info {
  justify-content: center;
  padding-right: 0.625rem;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
}
.main-container.container-fluid .flu-shot__info__title {
  font-size: 1.1em;
  color: var(--brand-50);
  font-weight: var(--font-weight-normal);
  margin: 0;
}
.main-container.container-fluid .flu-shot__info__description {
  font-weight: var(--font-weight-book);
  font-size: 0.9em;
}
.main-container.container-fluid .flu-shot__info__receipts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 1rem;
}
.main-container.container-fluid .flu-shot__info__receipts span {
  margin: 0 0.625rem;
  cursor: pointer;
}
.main-container.container-fluid .flu-shot__info__receipts ods-button::part(button) {
  background: transparent;
  color: inherit;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
}
.main-container.container-fluid .flu-shot__info__receipts ods-button::part(label) {
  color: #000;
}
.main-container.container-fluid .flu-shot__info__receipts i {
  color: var(--brand-50);
  padding: 0 0.125rem;
}
.main-container.container-fluid .flu-shot__info__receipts ods-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.2rem;
  width: 1.5rem;
}
.main-container.container-fluid .flu-shot .action-btn__wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-container.container-fluid .flu-shot .action-btn__wrap ods-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  height: 3rem;
  width: 1.5rem;
}
.main-container.container-fluid .flu-shot .action-btn__wrap ods-icon[variant=more] {
  color: var(--ods-color-gray-60);
}
.main-container.container-fluid .flu-shot .action-btn-lg:focus-visible {
  outline: 3px solid var(--brand-50);
  outline-offset: 2px;
}
.main-container.container-fluid .flu-shot.locked .action-btn-lg:not(.denied) .text {
  background: var(--neutral-10) !important;
  color: var(--neutral-20-hover) !important;
}
.main-container.container-fluid .flu-shot.locked .action-btn-lg:not(.denied) .icon {
  background: var(--neutral-10-hover) !important;
  color: var(--neutral-30) !important;
}
/*# sourceMappingURL=vaccination-verifications.component.css.map */
